export default __webpack_public_path__ + "static/media/notifications_help.973d88ed.png";